import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { map } from 'rxjs/operators';

import {CommunicationService} from '../services/communication.service';
import {
  AdminUserResponse,
  CreateAdminRequestData,
  DeleteAdminResponse,
  PermissionGroupResponse,
  RolePermissionGroup,
  RolePermissions
} from './administration.domain';

@Injectable()

export class AdministrationService {

  constructor(private communicationService: CommunicationService) { }

  getAllAdminUsers(): Observable<AdminUserResponse> {
    return this.communicationService.getData('adminuser');
  }

  getPermissionGroupData(): Observable<RolePermissionGroup[]> {
    return this.communicationService.getData<PermissionGroupResponse[]>('permissiongroup')
      .pipe(
        map(permissionGroups => permissionGroups.map(permissionGroup => {
          // Legacy backend returns allowed-groups, GOP backend returns allowed_groups
          const allowedGroups: string[] = permissionGroup.allowed_groups || permissionGroup['allowed-groups'] || [];

          return {
            role: permissionGroup.role,
            canManageAuth: allowedGroups.includes(RolePermissions.canManageAuth),
            canManageConcessions: allowedGroups.includes(RolePermissions.canManageConcessions),
            canManageOrders: allowedGroups.includes(RolePermissions.canManageOrders),
            canViewOrders: allowedGroups.includes(RolePermissions.canViewOrders),
          };
        })));
  }

  createNewAdmin(requestData: CreateAdminRequestData): Observable<any> {
    return this.communicationService.postData('adminuser', requestData);
  }

  deleteAdminUser(technicianId: string): Observable<DeleteAdminResponse> {
    return this.communicationService.deleteData(`adminuser?technician_id=${technicianId}`);
  }
}
